<template>
  <div class="modal fade" tabindex="-1" :id="id">
      <div class="modal-dialog modal-lg" role="document">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title"> {{$t('company.label.location')}}</h5>
  
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
  
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                      fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                      fill="currentColor" />
                  </svg>
                </span>
              </div>
            </div>
            <div class="modal-body">
              <MapComponent v-if="id && editForm.id" :id="editForm.id" @setLocate="getLocate" :latitude="latitude" :longitude="longitude"/>
            </div>
          
            <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isProcessing"></Button>
              </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>

  import {ref, defineProps, watch} from "vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import {useI18n} from "vue-i18n";
  import MapComponent from "@/components/MapComponent.vue";

  const store = useStore()

  const props = defineProps({
    id: {
      type: String,
      default: 'kt_modal_'
    },
    editForm : {
      type: Object,
      default: () => ({
        id: null,
        name: '',
        society_email: '',
        rccm_number: '',
        ifu_number: '',
        phone_code: '',
        phone: '',
        city: '',
        currency_id:'',
        country_id:'',
        zipcode: '',
        address: '',
        headquarters_address: '',
        legal_form: '',
        logo_url: null,
        online: true,
        image_url: null,
        longitude: '',
        latitude: ''
      })
    },

  })

  const formData = ref(props.editForm)

  const isProcessing = ref(false)
  const longitude = ref('');
  const latitude = ref('');
  const address = ref('');

  watch(() => props.editForm, (newVal) => {
    longitude.value = newVal?.longitude || '';
    latitude.value = newVal?.latitude || '';
    address.value = newVal?.address || '';
  }, { immediate: true, deep: true });

  const emit = defineEmits(['load'])
  const { t } = useI18n({ useScope: 'global' })

  function getLocate(locate) {
    latitude.value = locate.latitude
    longitude.value = locate.longitude
    address.value = locate.location
  }

  function closeModal(){
    if(props.hasParent){
      $("#"+props.parent).modal('toggle')
    }
    $("#" + props.id).modal('hide')
  }

  function submitForm() {
    isProcessing.value = true

    store.dispatch('multiSociety/updateSociety', {
      ...formData.value, 
      longitude: longitude.value, 
      latitude: latitude.value,
      address: address.value
    })
      .then(response => {
        closeModal()
        emit('load')
        window.toastr.success(t('notification.save_location'))
        isProcessing.value = false;
      })
      .catch(err => {
        isProcessing.value = false;
      });
  }
  </script>
  
  <style scoped></style>
  